/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import {Link} from 'react-router-dom'
import {Trans} from 'react-i18next'

export default function NavMobileUnit(props) {
    return (
        <li className={props.location.pathname.startsWith(`${props.path}`) ? "active" : ""}
        >
            <Link to={props.path}><Trans>{props.title}</Trans></Link>
        </li>
    )
}
